import {api} from "./api";

export const getLandingLeads = async (params) => {
  const res = await api.get("/landing-leads/admin", { params });
  return res.data;
};

export const getLandingLead = async (id) => {
  const res = await api.get(`/landing-leads/admin/${id}`);
  return res.data;
};

export const deleteLandingLead = async (id) => {
  const res = await api.delete(`/landing-leads/admin/${id}`);
  return res.data;
};
